import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const iconArray = [
    <FontAwesomeIcon icon="fa-solid fa-mug-hot"/>,
    <FontAwesomeIcon icon="fa-solid fa-lemon" />,
    <FontAwesomeIcon icon="fa-solid fa-flask" />,
    <FontAwesomeIcon icon="fa-solid fa-mug-hot"/>,
    <FontAwesomeIcon icon="fa-solid fa-lemon" />,
    <FontAwesomeIcon icon="fa-solid fa-flask" />,
    <FontAwesomeIcon icon="fa-solid fa-beer-mug-empty" />,
    <FontAwesomeIcon icon="fa-solid fa-beer-mug-empty" />,
    <FontAwesomeIcon icon="fa-solid fa-plane" />,
    <FontAwesomeIcon icon="fa-solid fa-plane" />,
    <FontAwesomeIcon icon="fa-solid fa-earth-americas" />,
    <FontAwesomeIcon icon="fa-solid fa-earth-americas" />,
    <FontAwesomeIcon icon="fa-solid fa-briefcase" />,
    <FontAwesomeIcon icon="fa-solid fa-briefcase" />,
    <FontAwesomeIcon icon="fa-solid fa-key" />,
    <FontAwesomeIcon icon="fa-solid fa-key" />
]

// Shuffle logic:

export function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

shuffle(iconArray);

export default iconArray;